import { render, staticRenderFns } from "./wage-set.vue?vue&type=template&id=12f2e5f1&"
import script from "./wage-set.vue?vue&type=script&lang=ts&"
export * from "./wage-set.vue?vue&type=script&lang=ts&"
import style0 from "./wage-set.vue?vue&type=style&index=0&id=12f2e5f1&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports